/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum SubscriptionEnum {
    All = 'all',
    Premium = 'premium',
    PremiumPlus = 'premiumPlus',
    PastDue = 'pastDue',
    Free = 'free'
}

export function SubscriptionEnumFromJSON(json: any): SubscriptionEnum {
    return SubscriptionEnumFromJSONTyped(json, false);
}

export function SubscriptionEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionEnum {
    return json as SubscriptionEnum;
}

export function SubscriptionEnumToJSON(value?: SubscriptionEnum | null): any {
    return value as any;
}

